import Alert from "@mui/material/Alert";
import { CertificateAuditResource, useCertificateDownload } from "services/useCertificateDownload";
import React, { useRef, useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import clsx from "clsx";
import CircularProgress from "@mui/material/CircularProgress";
import { alpha } from "@mui/material/styles";

// Custom.
import { useStyles } from "./styles";

export interface DownloadButtonProps {
  document: React.ReactElement;
  auditResource: CertificateAuditResource;
  fileName?: string;
  className?: string;
}

const DownloadButton: React.FC<DownloadButtonProps> = (props) => {
  const { document, fileName, className } = props;
  const classes = useStyles();
  const audit = useCertificateDownload(props.auditResource);
  const [showButton, setShowButton] = useState(false);
  const downloadButton = useRef<any>(null);

  // Methods.

  const handleDownload = async () => {
    if (audit.loading || !(await audit.record())) return;
    try {
      setShowButton(true);
      setTimeout(() => {
        downloadButton?.current?.click();
      }, 500);
    } catch (error: any) {
      console.log("error", error);
    }
  };

  return (
    <div className={clsx(classes.root, className)}>
      <IconButton
        className={classes.iconButton}
        aria-label="download"
        onClick={handleDownload}
        disabled={audit.loading}
      >
        <CloudDownloadIcon />
      </IconButton>
      {audit.error && <Alert severity="error">{audit.error}</Alert>}
      {showButton && (
        <PDFDownloadLink document={document} fileName={fileName}>
          {({ blob, url, loading, error }) =>
            loading ? (
              <Box
                sx={(theme) => ({
                  alignItems: "center",
                  bgcolor: alpha(theme.palette.grey[50], 0.5),
                  display: "flex",
                  justifyContent: "center",
                  left: 0,
                  bottom: 0,
                  position: "absolute",
                  right: 0,
                  top: 0,
                  zIndex: 1,
                })}
              >
                <CircularProgress size={20} />
              </Box>
            ) : (
              <Box
                ref={downloadButton}
                component="span"
                sx={{ height: 0, width: 0 }}
              ></Box>
            )
          }
        </PDFDownloadLink>
      )}
    </div>
  );
};

export default DownloadButton;
